import styled from 'styled-components';

import { Container as MenuContainer } from '~/components/Details/InstanceDetails/MenuInstances/styles';
import { Container as ProcessContainer } from '~/components/Details/ProcessDetails/styles';
import grid from '~/styles/grid';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;

  ${MenuContainer} {
    margin-right: ${grid.sm};
  }

  ${ProcessContainer} {
    margin: ${grid.lg} ${grid.lg} 8.57rem 0;
  }
`;

export const EmptyContainer = styled.div`
  color: #808080;
  display: flex;
  gap: ${grid.lg};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${() =>
    `calc(100vh - 80px - 2.357rem - ${grid.md} - ${grid['7xl']})`};
  font-size: ${grid.lg};
`;

export const ProcessDetailsContainer = styled.div``;

export const ProcessDetailsHeader = styled.h3`
  font-size: ${grid.md};
  padding: ${grid.md} ${grid.sm} 0 ${grid.sm};
  margin: 0;
`;
